module.exports = __webpack_public_path__ + "static/img/pic5.0dc3680a.png";